<template>
  <div>
    <Pos_manage_service/>
  </div>
</template>

<script>
import Pos_manage_service from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_manage_service";
export default {
  name: "PosManageService",
  components: {
    Pos_manage_service
  }
}
</script>

<style scoped>

</style>
